module.exports = __webpack_public_path__ + "img/NochLächelnSie.feb5a1b6.svg";